// src/components/view-profile/EmptyState.js
import React from "react";
import { Link } from "react-router-dom";

const EmptyState = ({ icon: Icon, title, description, action }) => {
  return (
    <div className="text-center py-8 px-4">
      <div className="w-16 h-16 bg-gray-100 dark:bg-neutral-800 rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon className="w-8 h-8 text-gray-400" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{title}</h3>
      <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md mx-auto text-sm">
        {description}
      </p>
      {action && (
        <Link
          to={action.to}
          className="inline-flex items-center px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium text-sm"
        >
          {action.label}
        </Link>
      )}
    </div>
  );
};

export default EmptyState;